const FIELD_LABELS = {
  categoryId: 'Categoria',
  description: 'Descrição',
  externalCode: 'Código externo',
  itemId: 'Item',
  max: 'Máximo',
  min: 'Mínimo',
  name: 'Nome',
  price: 'Preço',
  productId: 'Produto',
  status: 'Status',
  text: 'Resposta',
};

const normalizeFieldLabel = (field) => {
  const raw = String(field || '').trim();
  if (!raw) return '';
  const leaf = raw.split('.').filter(Boolean).pop() || raw;
  return FIELD_LABELS[leaf] || leaf.replace(/([a-z])([A-Z])/g, '$1 $2');
};

const translateProviderMessage = (message) => {
  const value = String(message || '').trim();
  if (!value) return '';
  return value
    .replace(/must be a UUID/gi, 'deve possuir um identificador válido')
    .replace(/must be a valid UUID/gi, 'deve possuir um identificador válido')
    .replace(/is required/gi, 'é obrigatório')
    .replace(/must not be null/gi, 'é obrigatório')
    .replace(/must be greater than zero/gi, 'deve ser maior que zero');
};

const formatFieldError = (detail) => {
  const field = normalizeFieldLabel(detail?.field);
  const rawField = String(detail?.field || '').trim();
  let message = translateProviderMessage(detail?.message || detail?.code);
  if (rawField && message.toLowerCase().startsWith(rawField.toLowerCase())) {
    message = message.slice(rawField.length).replace(/^\s*[:.-]?\s*/, '');
  }
  if (field && message) return `${field}: ${message}`;
  return field || message;
};

export const getIfoodErrorInfo = (error, fallback = 'Não foi possível concluir a ação.') => {
  const response = error?.response?.data || {};
  const code = String(response.code || '');
  const category = String(response.category || '');
  const rawMessage = String(response.error || response.message || error?.message || fallback).trim();
  const normalizedMessage = rawMessage.toLowerCase();
  const transportCode = String(error?.code || '').toUpperCase();
  const isNetworkError = !error?.response && (
    transportCode === 'ERR_NETWORK'
    || normalizedMessage === 'network error'
    || normalizedMessage.includes('failed to fetch')
  );
  const isTimeout = !error?.response && (
    transportCode === 'ECONNABORTED'
    || transportCode === 'ETIMEDOUT'
    || normalizedMessage.includes('timeout')
  );
  const message = isNetworkError
    ? 'Não foi possível conectar ao sistema para consultar o iFood.'
    : isTimeout
      ? 'A consulta ao iFood demorou mais do que o esperado.'
      : rawMessage;
  const action = String(response.action || '').trim();
  const fields = Array.isArray(response?.details?.fields)
    ? response.details.fields.map(formatFieldError).filter(Boolean)
    : [];

  return {
    message: message || fallback,
    action: action || (isNetworkError || isTimeout
      ? 'Verifique sua internet e tente novamente. Se o problema continuar, informe ao suporte o nome da loja e o horário da tentativa.'
      : ''),
    fields,
    code,
    category,
    requiresReauthorization: code === 'IFOOD_REAUTHORIZATION_REQUIRED'
      || (category === 'authorization' && Number(response?.details?.ifood_status) === 401),
    supportId: String(response?.details?.support_id || ''),
    requestId: String(response?.details?.request_id || ''),
    providerMessage: String(response?.details?.provider_message || ''),
  };
};

export const getIfoodErrorMessage = (error, fallback) => {
  const info = getIfoodErrorInfo(error, fallback);
  const fieldSummary = info.fields.slice(0, 3).join('; ');
  const providerSummary = info.category === 'user_input' && !fieldSummary && info.providerMessage
    ? `Motivo informado pelo iFood: ${translateProviderMessage(info.providerMessage)}.`
    : '';
  return [
    info.message,
    fieldSummary ? `Detalhes: ${fieldSummary}.` : '',
    providerSummary,
    info.action,
    info.supportId ? `Código para suporte: ${info.supportId}.` : '',
  ].filter(Boolean).join(' ');
};
